import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { UnauthorizedIcon } from "../../../icons/errors";

export const UnauthorizedError: FC<IErrorComponent> = (props) => {
  const message = "Не удалось получить информацию о"
    + " выданных продуктах, попробуйте обновить страницу";

  return (
    <ErrorTemplate
      {...props}
      icon={UnauthorizedIcon}
      message={message}
      showTechInfo={true}
    />
  );
};
